import HrFileCategoryForm from 'components/forms/hr/HrFileCategoryForm';

/** Route entry for creating or editing an HR file category. */
export default function HrFileCategoryFormPage() {
  return <HrFileCategoryForm />;
}
